(() => {
 if(window.RahalaCompareInsights)return;
 const config=document.currentScript?.dataset||{};
 const endpoint=config.insightsEndpoint;
 let url;try{url=new URL(endpoint);if(url.protocol!=='https:'||url.pathname!=='/collect'||url.search||url.hash)return;}catch{return;}
 const qa=new URLSearchParams(location.search).has('rahala_compare_qa');
 const preview=config.themeRole!=='main'||config.designMode==='true'||new URLSearchParams(location.search).has('preview_theme_id');
 if(preview&&!qa)return;
 if(qa)url.pathname+='/qa';
 const key=qa?'rahala-compare-insights-qa-session-v1':'rahala-compare-insights-session-v1';
 const names=new Set(['view','use','picker','selection','filter','product_click','contact_click','entry_view','entry_click']);
 const consent=()=>{try{return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;}catch{return false;}};
 const session=()=>{
  if(!consent())return null;
  try{const now=Date.now();let s=JSON.parse(sessionStorage.getItem(key)||'null');if(!s||now-s.at>1800000||!/^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/.test(s.id))s={id:crypto.randomUUID(),at:now};s.at=now;sessionStorage.setItem(key,JSON.stringify(s));return s.id;}catch{return null;}
 };
 const record=(name,p={})=>{
  if(!names.has(name)||!consent())return false;
  const id=session();if(!id)return false;
  const payload={id:crypto.randomUUID(),session:id,name,consent:true,mode:qa?'qa':'customer',at:new Date().toISOString(),language:document.documentElement.lang==='ar'?'ar':'en',device:matchMedia('(max-width: 749px)').matches?'mobile':'desktop',bags:String(p.compare_bag_ids||'').split(',').filter(x=>/^\d{8,20}$/.test(x)).slice(0,3),product:/^\d{8,20}$/.test(String(p.compare_product_id||''))?String(p.compare_product_id):null};
  // Never attach URLs, searches, customer identity, credentials, order values or arbitrary event properties.
  fetch(url.href,{method:'POST',mode:'cors',credentials:'omit',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)}).catch(()=>{});return true;
 };
 const forget=()=>{try{sessionStorage.removeItem(key);}catch{}};
 document.addEventListener('visitorConsentCollected',()=>{if(!consent())forget();});
 window.RahalaCompareInsights={record,session,forget};
})();
